import { mergeStyleSets, getTheme, IStackTokens } from "@fluentui/react";

const theme = getTheme();

const styles = mergeStyleSets({
  container: {
    height: "100%",
  },
  // Warning area styling
  warningIcon: {
    fontSize: "70px",
    color: theme.palette.neutralPrimary,
    marginBottom: "16px",
  },
  title: {
    fontWeight: "600",
    color: theme.palette.neutralPrimary,
    textAlign: "center" as const,
  },
  description: {
    color: theme.palette.neutralSecondary,
    textAlign: "center" as const,
    maxWidth: "600px",
    lineHeight: "1.5",
  },
  extensionName: {
    fontStyle: "italic",
  },
  actionSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginBottom: "48px",
  },
  secondaryAction: {
    minWidth: "180px",
  },
  // Browse other extensions card
  browseCard: {
    background: theme.palette.themeLighterAlt,
    borderRadius: "8px",
    padding: "24px",
    border: `1px solid ${theme.palette.neutralLight}`,
    maxWidth: "600px",
    width: "100%",
    marginBottom: "24px",
  },
  browseIcon: {
    fontSize: "20px",
    color: theme.palette.themePrimary,
  },
  browseContent: {
    flex: 1,
  },
  browseTitle: {
    fontWeight: "600",
    color: theme.palette.neutralPrimary,
    marginBottom: "4px",
  },
  browseSubtitle: {
    color: theme.palette.neutralSecondary,
    fontSize: "14px",
  },
  browseDropdownSection: {
    marginTop: "16px",
  },
  browseDropdown: {
    width: "100% !important",
  },
  saveExtensionMappingWarningIcon: {
    color: theme.palette.orange,
    marginRight: "8px",
  },
  saveExtensionMappingWarning: {
    display: "flex",
    alignItems: "center",
    border: `1px solid ${theme.palette.orange}`,
    padding: "8px",
    borderRadius: "4px",
    color: theme.palette.orange,
    backgroundColor: "rgba(255, 185, 0, 0.1)",
  },
});

const stackTokens: IStackTokens = {
  childrenGap: 20,
  padding: 20,
};

const contentStackTokens: IStackTokens = {
  childrenGap: 20,
};

export { styles, stackTokens, contentStackTokens };
